<template>
  <div class="space-y-4">
    <Index
      v-if="page == 'index'"
      :corporate="corporate"
      :changePage="changePage"
    ></Index>
    <AddAccount
      v-if="page == 'add'"
      :changePage="changePage"
      :corporate="corporate"
    ></AddAccount>
    <EditAccount
      v-if="page == 'edit'"
      :changePage="changePage"
      :account="account"
    ></EditAccount>
  </div>
</template>

<script>
import Index from "@/views/Corporate/Accounts/Index";
import AddAccount from "@/views/Corporate/Accounts/AddAccount";
import EditAccount from "@/views/Corporate/Accounts/EditAccount";
export default {
  props: ["corporate"],
  components: { Index, AddAccount, EditAccount },
  data() {
    return {
      page: "index",
      account: null
    };
  },
  created() {},
  methods: {
    changePage(page, account) {
      this.page = page;
      if (account) {
        this.account = account;
      } else {
        this.account = null;
      }
    }
  }
};
</script>
